export const DEFAULT_AXIOMA_FACTOR_DATA_MODEL = 'AXWWLM4-MH';
export const DEFAULT_BARRA_FACTOR_DATA_MODEL = 'GEMLTL100';
export const IDIO_VOL_SOURCE_STANDARD = 'standard';
export const IDIO_VOL_SOURCE_AI = 'ai';
export const AI_IDIO_VOL_MSI_V2_LOCALID_READY = false;
export const AI_IDIO_VOL_DISABLED_REASON = 'Temporarily unavailable until AI predictions use the MSI v2 Barra LOCALID identity contract.';
export const BARRA_SHORT_HORIZON_COMING_SOON_TOOLTIP = 'Coming soon';

export const AXIOMA_FACTOR_DATA_MODEL_OPTIONS = [
    {
        value: 'AXWWLM4-MH',
        label: 'AXWWLM4-MH',
        description: 'Default Axioma medium-horizon factor set.',
    },
    {
        value: 'AXWWLM4-SH',
        label: 'AXWWLM4-SH',
        description: 'Axioma short-horizon factor set.',
    },
];

export const BARRA_FACTOR_DATA_MODEL_OPTIONS = [
    {
        value: 'GEMLTL100',
        label: 'GEMLTL100',
        description: 'Barra long-horizon global equity model.',
    },
    {
        value: 'GEMLTS100',
        label: 'GEMLTS100',
        description: 'Barra short-horizon global equity model.',
        disabled: true,
        tooltip: BARRA_SHORT_HORIZON_COMING_SOON_TOOLTIP,
    },
];

export function getAvailableBarraFactorDataModelOptions() {
    return BARRA_FACTOR_DATA_MODEL_OPTIONS.filter((option) => !option.disabled);
}

export function normalizeRiskSource(value) {
    return String(value || '').trim().toLowerCase();
}

export function normalizeUserFactorModel(value) {
    return normalizeRiskSource(value) === 'axioma' ? 'axioma' : 'barra';
}

export function formatUserFactorModel(value) {
    return normalizeUserFactorModel(value) === 'axioma' ? 'Axioma' : 'Barra';
}

export function normalizeIdioVolSource(value) {
    return String(value || '').trim().toLowerCase() === IDIO_VOL_SOURCE_AI
        ? IDIO_VOL_SOURCE_AI
        : IDIO_VOL_SOURCE_STANDARD;
}

export function supportsAiIdioVolForFactorModel(factorModel) {
    return AI_IDIO_VOL_MSI_V2_LOCALID_READY
        && normalizeUserFactorModel(factorModel) === 'barra';
}

export function coerceIdioVolSourceForFactorModel(factorModel, idioVolSource) {
    if (!supportsAiIdioVolForFactorModel(factorModel)) {
        return IDIO_VOL_SOURCE_STANDARD;
    }
    return normalizeIdioVolSource(idioVolSource);
}

export function normalizeAxiomaFactorDataModel(value) {
    const text = String(value || '').trim().toUpperCase();
    return text === 'AXWWLM4-SH' ? 'AXWWLM4-SH' : DEFAULT_AXIOMA_FACTOR_DATA_MODEL;
}

export function normalizeBarraFactorDataModel(value) {
    const text = String(value || '').trim().toUpperCase().replace(/[^A-Z0-9]/g, '');
    return getAvailableBarraFactorDataModelOptions().some((option) => option.value === text)
        ? text
        : DEFAULT_BARRA_FACTOR_DATA_MODEL;
}

export function normalizeFactorDataModel(riskSource, value) {
    const normalizedRiskSource = normalizeRiskSource(riskSource);
    if (normalizedRiskSource === 'axioma') {
        return normalizeAxiomaFactorDataModel(value);
    }
    if (normalizedRiskSource === 'barra') {
        return normalizeBarraFactorDataModel(value);
    }
    return null;
}

export function getEffectiveFactorDataModel(factorModel, axiomaModel, barraModel) {
    const normalizedRiskSource = normalizeRiskSource(factorModel);
    if (normalizedRiskSource === 'axioma') {
        return normalizeAxiomaFactorDataModel(axiomaModel);
    }
    if (normalizedRiskSource === 'barra') {
        return normalizeBarraFactorDataModel(barraModel);
    }
    return null;
}
